import './Switch.css';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../../utils/querystring';
import addQueryString, { removeQueryString } from '../../Listing';
import { isNil } from '../../../utils/IsNil';
import { splitter } from '../../RecommendationListing';
import { TYPE } from '../../../utils/constants';
import { get } from '../../../utils';
var Switch = function Switch(_ref) {
  var tagsToDisplay = _ref.tagsToDisplay,
    fields = _ref.fields,
    rtl = _ref.rtl,
    moveToSlide = _ref.moveToSlide;
  var history = useHistory();
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var queriesType = queryParams[TYPE];
  var type = 'radio';
  var checkboxes = React.useRef();
  var setChecked = function setChecked(key, index) {
    var isChecked = false;
    if (index === 0 && isNil(queriesType)) {
      addQueryString(TYPE, key, history);
      isChecked = true;
    }
    if (queriesType && queriesType.replaceAll("+", " ") === key) {
      isChecked = true;
    }
    return isChecked;
  };
  var submitFilters = function submitFilters(e) {
    var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    var selectedCheckboxes = [];
    for (var i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(TYPE, selectedCheckboxes, history);
    moveToSlide(0);
  };
  useEffect(function () {
    return function () {
      removeQueryString(TYPE, history);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: "g-checkbox g-checkbox--mob-scroll ".concat(type === 'radio' ? 'g-checkbox-notick' : '')
  }, tagsToDisplay.length ? tagsToDisplay.map(function (key, index) {
    var tabTitle = get(get(fields, "data.datasource.items")[index], 'tabTitle.jss.value');
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, index),
      type: type,
      className: "fp__checkbox",
      id: "gct1-".concat(key + index),
      name: "gct1",
      title: tabTitle || key,
      onChange: function onChange(event) {
        submitFilters(event);
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: "gct1-".concat(key + index)
    }, tabTitle || key));
  }) : null)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyle : ltrStyle)
  }, children);
};
export default Switch;
export var commonStyles = "c1s1tdyb";
var ltrStyle = "l1baadki";
var rtlStyle = "r1y18g5o";